import ApproveDetailsPage from 'Components/Admin/ApproveDetailsPage';
import { approveUserApi, approveUserChangeOrgApi, checkIfFirmClaimedApi, DEFAULTAVATAR, denyUserApi, raiseNotificationApi } from 'Constants'
import React, { useContext, useState } from 'react'
import { Context } from 'Context/Context';
import { Check, X, Maximize2, User } from 'lucide-react';
import { toast } from 'react-toastify';

// Grid shared with the queue header in ApprovalQueue.jsx (design 19b)
export const QUEUE_GRID = '56px minmax(0,1.1fr) minmax(0,1.6fr) minmax(0,1.3fr) minmax(0,1.3fr) 130px';

const withProtocol = (url) => !url ? '' : (/^https?:\/\//i.test(url) ? url : 'https://' + url);



function ListElement({item, setUpdateList, keyVal}) {
    const [showModal, setShowModal] = useState(false);
    const [openInDeny, setOpenInDeny] = useState(false);
    const feedbackMsg = "";

    const {makeApiCallFunc, setAwaitCount} = useContext(Context);
    const getDataToShow = (label) => {
      if(item?.updatedUserInfo?.[label] && item?.updatedUserInfo[label].newValue)
      {
          return item?.updatedUserInfo[label].newValue;
      }
      else
      {
        return item.user[label]
      }
    }
    const buildPostData = () => 
      {
           const postData = {};
            const updatedUserInfo = item.updatedUserInfo;
            const user = item.user;
           Object.entries(updatedUserInfo).map((iitem)=>{
                const {newValue} = updatedUserInfo[iitem[0]];
                console.log(iitem[0])
                if(item?.changeOrg === true || (item?.changeOrg === false && iitem[0] !== "casePref" && iitem[0] !== "statePref"))
                {
                  postData[iitem[0]] = newValue;
                }
           })
           return postData;
      }
      const approveUser = () => {
           const postData = buildPostData();
           const updatedUserInfo = item.updatedUserInfo;
            const details = item;
           postData.verified = true;
           console.log(postData);
           if(item.changeOrg)
           {
               makeApiCallFunc(
                   approveUserChangeOrgApi, 
                   {
                       email: details.user.email, 
                       newEmail: updatedUserInfo?.email?.newValue,
                       newProfile: {...postData, legalType: details?.user?.legalType, role: 2, isUserAssistant: false},
                       accountId: details._id,
                   },
                   ({data})=>
                   {
                      toast.success('Firm switch approved');
                      setUpdateList(prev => !prev)
                   },function (error) {
                   console.log(error)
                   //setApiError(error?.response?.data?.message);
               })
           }
           else
           {
                  if(item?.updatedUserInfo?.lawFirmId?.newValue !== item?.user?.lawFirmId)
                  {
                    //check if selected firm is already with another user
                    makeApiCallFunc(checkIfFirmClaimedApi, {firmId: item?.updatedUserInfo?.lawFirmId?.newValue}, 
                      (response) => {
                        if(response?.data?.claimed)
                        {
                            toast.error(`This firm is already claimed by ${response?.data?.claimedBy}. Please deny this user verification with valid message.`);
                            return;
                        }
                        else
                        {
                            approveUserFinal(postData, details);
                        }
                    },
                    (error) => {
                        console.error("Error checking firm claim status:", error);
                        toast.error("Error checking firm claim status. Please try again.");
                    });
                  }
                   else
                   {
                      approveUserFinal(postData, details);
                   }
           }
           

      }
      const approveUserFinal = (postData, details) => {
        makeApiCallFunc(
                   approveUserApi, 
                   {
                       user: postData, 
                       accountId: details._id, 
                       userId: details?.user._id, 
                       isEmailUpdate: details?.user?.verified, 
                   },
                   ({data})=>
                   {
                       toast.success(details?.user?.verified ? 'Profile update approved' : 'Account verified');
                       notifyUser(true, data?.verifiedEmailSent); // the server already emailed a verified law firm its saved cases
                       setAwaitCount(data?.awaits)
                   },function (error) {
                   console.log(error)
                   //setApiError(error?.response?.data?.message);
               })
              }
      const notifyUser = (isVerified, emailAlreadySent = false) => {
        const user = item.user;
        const notificationObj = {
          title : isVerified ?
          (user.verified ? "Account details approved and updated" : "Your account has been verified" )
          : 
          (user.verified ? "Your details has been rejected by the admin"  : "Your account details has been rejected and so is not verified"  ),
          is_read : false,
          sender: "admin",
          type: (isVerified ? "1" : "2"),
          notificationCategory: 0,
          receiver: user?._id,
          // in-app notification only - the email already went out from the server
          ...(emailAlreadySent ? { doNotSendEmail: true } : {}),
          content: 
          (isVerified ? 
            (user.verified ? 
            "Your account information has been verified and approved by the Admin."
            :
            "Congratulations your account has been verified. Now you shall start to request for the detailed view of the cases" )
            :
            (user.verified ? 
             "Your updates to the account has been denied by admin with the feedback - '"+feedbackMsg + "' .Please make the necessary changes and try again"  
                :
             "Your account has been denied verification with the feedback from the admin - '"+feedbackMsg + "' .Please make the necessary changes and try again"  
             )
             )
        }
        const successCallback = (data) => {
          console.log(data); 
          setUpdateList(prev => !prev)

        }
        const errorCallback = (data) => {
            console.log(data);
        }
        makeApiCallFunc(
            raiseNotificationApi, 
            notificationObj, 
            successCallback,
            errorCallback
            )
      }
         
  const name = [getDataToShow("firstName"), getDataToShow("lastName")].filter(Boolean).join(' ');
  const pic = !item?.user?.isUserFunder ? getDataToShow("profilePic") : null;
  const website = getDataToShow("lawFirmLink");
  const openDetails = (deny = false) => { setOpenInDeny(deny); setShowModal(true); };
  const iconBtn = (label, bg, color, Icon, onClick) => (
    <button
      type='button'
      title={label}
      aria-label={label}
      onClick={(e) => { e.stopPropagation(); onClick(); }}
      className='flex items-center justify-center transition-opacity hover:opacity-80'
      style={{ width: '28px', height: '28px', borderRadius: '5px', background: bg }}
    >
      <Icon size={15} strokeWidth={2.2} color={color} />
    </button>
  );

  return (
    <>
    {
      showModal &&
      <ApproveDetailsPage uploadNew={showModal} onClose={() => setShowModal(false)} item={item} setUpdateList={setUpdateList} initialDeny={openInDeny}/>
    }
      <div
        onClick={() => openDetails(false)}
        className='grid items-center cursor-pointer transition-colors bg-white hover:!bg-[rgba(138,98,49,0.04)] font-plexsans'
        style={{ gridTemplateColumns: QUEUE_GRID, borderTop: '1px solid rgba(20,33,61,.08)' }}
      >
        <div style={{ padding: '14px 16px' }}>
          <div className='flex items-center justify-center overflow-hidden rounded-full' style={{ width: '30px', height: '30px', background: 'rgba(20,33,61,.08)' }}>
            {pic ? <img src={pic} alt="" className='w-full h-full object-cover' /> : <User size={15} strokeWidth={2} color='rgba(20,33,61,.45)' />}
          </div>
        </div>
        <div className='truncate' style={{ padding: '14px 16px', font: "500 13px/1.3 'IBM Plex Sans',sans-serif", color: '#14213d' }}>{name || '—'}</div>
        <div className='truncate' style={{ padding: '14px 16px', fontSize: '12.5px', color: 'rgba(20,33,61,.6)' }}>{getDataToShow("email") || '—'}</div>
        <div className='truncate' title={getDataToShow("company") || ''} style={{ padding: '14px 16px', fontSize: '12.5px', color: 'rgba(20,33,61,.6)' }}>{getDataToShow("company") || '—'}</div>
        <div className='truncate' style={{ padding: '14px 16px', fontSize: '12.5px' }}>
          {website ?
            <a target="_blank" rel="noopener noreferrer" onClick={(e) => e.stopPropagation()} href={withProtocol(website)} style={{ color: '#8a6231', textDecoration: 'underline' }}>{website}</a>
            : <span style={{ color: 'rgba(20,33,61,.3)' }}>—</span>}
        </div>
        <div className='flex items-center justify-end' style={{ padding: '14px 16px', gap: '8px' }}>
          {iconBtn('Approve', 'rgba(58,125,79,.1)', '#3a7d4f', Check, approveUser)}
          {iconBtn('Deny', 'rgba(154,59,46,.1)', '#9a3b2e', X, () => openDetails(true))}
          {iconBtn('View details', 'rgba(20,33,61,.06)', '#14213d', Maximize2, () => openDetails(false))}
        </div>
      </div>
    </>
  )
}

export default ListElement